
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  admin
} from '../../components/advanced-ui/advanced-ui.route';
import { authenticationRoutingModule } from '../../components/authentication/authentication.route';
import { errorRoutingModule } from '../../components/error/error.route';
// import { landRoutingModule } from '../../components/pages/landing.route';

export const authen: Routes = [
  {
    path: '',
    children: [
 
       ...authenticationRoutingModule.routes,
       ...errorRoutingModule.routes,
      //  ...landRoutingModule.routes,
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(admin)],
  exports: [RouterModule],
})
export class SaredRoutingModule {}
